import React, { useEffect, useState } from "react";
import classes from "./TripCards.module.css";
import { useNavigate } from "react-router-dom";

const TripCards = (props) => {
  const tripData = props.tripData;
  const monthName = props?.monthName?.substr(0,3);
  const navigate = useNavigate();
  const cardsWeb = (
    <>
      <div className={classes["trip-container"]}>
        {tripData.map((tr, tripCardIndex) => {
          return (
            <div
              className={classes["trip-card"]}
              // style={{
              //   marginRight: `${
              //     tripCardIndex + 1 === tripData.length && "0vw"
              //   }`,
              // }}
            >
              <div
                onClick={() => {
                  if (tr.tripIdAlias) {
                    navigate(`/trip/${tr.tripIdAlias}`);
                  } else {
                    navigate(`/trip/${tr.id}`);
                  }
                }}
                className={classes["upper-card"]}
              >
                <div className={classes["upper-card-img-container"]}>
                  <img
                    className={classes["upper-card-img"]}
                    src={
                      tr.cardImg ||
                      "https://static.wixstatic.com/media/da937f_53014b58846f4deab22e6e229df7e9a4~mv2.webp"
                    }
                    alt=""
                  />
                </div>
                <div
                  style={{
                    display: `${
                      tr.tripCategory && tr.tripCategory.length > 0
                        ? "flex"
                        : "none"
                    }`,
                  }}
                  className={classes["trip-category-container"]}
                >
                  <p className={classes["trip-category-text"]}>
                    {tr.tripCategory && tr.tripCategory.split(",")[0]}
                  </p>
                </div>
                <div
                  style={{
                    display: `${
                      tr.vacancy && tr.vacancy.length > 0 ? "flex" : "none"
                    }`,
                  }}
                  className={classes["vacancy-container"]}
                >
                  <p className={classes["vacancy-text"]}>{tr.vacancy}</p>
                </div>
              </div>

              <div className={classes["lower-card"]}>
                {
                props.monthName && tr[`${monthName}`] ? (
                  <p className={classes["lower-card-text"]}>
                    {tr[`${monthName}`]}
                  </p>
                ):
                <p className={classes["lower-card-text"]}>{tr.tripTitleLine}</p>
              }


                <p
                  style={{ color: "#e65439" }}
                  className={`${classes["lower-card-text"]} ${classes["lower-card-text-bold"]}`}
                >
                  {tr.tripPriceLine}
                </p>
                <p className={classes["lower-card-text"]}>{tr.curatorLine}</p>
                <button
                  onClick={() => {
                    if (tr.tripIdAlias) {
                      navigate(`/trip/${tr.tripIdAlias}`);
                    } else {
                      navigate(`/trip/${tr.id}`);
                    }
                  }}
                  className={classes["lower-card-button"]}
                >
                  More Details
                </button>
                <img
                  className={classes["lower-card-img"]}
                  src={tr.curatorImg}
                  alt=""
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );

  const cardsMobile = (
    <div className="lg:hidden flex flex-shrink-0 overflow-x-auto space-x-6 p-4 ps-4 pe-4">
      {tripData.map((tr, index) => (
        <div
          key={index}
          className="relative overflow-hidden"
          style={{ minWidth: "45%" }}
        >
          <img
            src={
              tr.cardImg ||
              "https://static.wixstatic.com/media/da937f_53014b58846f4deab22e6e229df7e9a4~mv2.webp"
            }
            alt="Travel"
            className="w-full h-40 rounded-lg"
          />
          {tr.tripCategory && (
            <div className="absolute top-32 left-0 ml-2">
              <span className="bg-blue-500 text-white text-xs font-semibold py-1 px-2 rounded-full">
                {tr.tripCategory.split(",")[0]}
              </span>
            </div>
          )}
          <div className="mt-2">
            <p className="text-lg font-semibold">{tr.tripTitleLine}</p>
          </div>
          <div className="mt-1">
            <p className="text-gray-600">{tr.tripPriceLine}</p>
          </div>
          <div className="mt-1">
            <p className="text-gray-600">{tr.curatorLine}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      {cardsWeb}
      {/* {cardsMobile} */}
    </>
  );
};

export default TripCards;
